import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login.vue";
import Store from "@/store";

Vue.use(VueRouter);

const { state } = Store;

const ifNotAuthenticated = (to, from, next) => {
  if (!state?.user?.token) {
    next();
    return;
  }
  next("/");
};
const ifAuthenticated = (to, from, next) => {
  if (state?.user?.token) {
    next();
    return;
  }
  next("/login");
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/Signup.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/pinpad-transactions",
    name: "PinpadTransactions",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/PinpadTransactions.vue"),
  },
  {
    path: "/pos-transactions",
    name: "PosTransactions",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/PosTransactions.vue"),
  },
  {
    path: "/bank-transfer",
    name: "BankTransfer",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/BankTransfer.vue"),
  },
  {
    path: "/account-opening",
    name: "AccountOpening",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/AccountOpening.vue"),
  },
  {
    path: "/top-agents",
    name: "TopAgents",

    component: () => import("../views/TopAgents.vue"),
  },
  {
    path: "/agent-list",
    name: "AgentList",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/AgentList.vue"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
